// extracted by mini-css-extract-plugin
module.exports = {"RivePillButton":"RivePillButton_RivePillButton__inKkR"};